module.exports = "../static/media/logo.b7ebecde.png";